import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import logo from '/img/logo.png';

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-[#022D9C] via-[#0D2C6F] to-[#021B55] text-white overflow-hidden">
      {/* Decorative SVG wave */}
      <div className="pointer-events-none -mt-1">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-20 block">
          <defs>
            <linearGradient id="g1" x1="0" x2="1">
              <stop offset="0%" stopColor="#0e1b40" stopOpacity="1" />
              <stop offset="100%" stopColor="#1a2b63" stopOpacity="1" />
            </linearGradient>
          </defs>
          <path d="M0,0 C300,100 900,0 1200,80 L1200,120 L0,120 Z" fill="url(#g1)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Column 1: Brand */}
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
			 <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg ring-2 ring-white/30">
				<img
				  src={logo}
				  alt="CBIU Logo"
				  className="h-12 w-12 object-contain"
				/>
			  </div>           
            <div>
              <h4 className="text-white font-bold">Cox's Bazar International University</h4>
              <p className="text-sm text-slate-300">Committed to knowledge and ethics</p>
            </div>
          </div>
          <p className="text-sm text-slate-300 max-w-sm">
            CBIU provides quality education with a focus on Islamic values and modern sciences. Stay connected for the
            latest updates and vacancies.
          </p>
          <div className="flex items-center gap-3 mt-3">
            <a href="#" aria-label="facebook" className="p-2 rounded-md bg-white/5 hover:bg-white/10 transition">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2.1v-2.9h2.1V9.1c0-2.1 1.2-3.3 3-3.3.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2v1.5h2.3l-.4 2.9h-1.9v7A10 10 0 0022 12z" />
              </svg>
            </a>
            <a href="#" aria-label="twitter" className="p-2 rounded-md bg-white/5 hover:bg-white/10 transition">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 5.9c-.6.3-1.2.5-1.9.6.7-.4 1.1-1 1.3-1.8-.6.4-1.3.6-2 .8C18.7 4.9 17.9 4 17 4c-1.8 0-3.1 1.7-2.7 3.4C9.7 7 6 5.1 3.8 2.2c-.9 1.6-.5 3.7 1 4.7-.5 0-1-.2-1.5-.4v.1c0 1.4 1 2.7 2.4 3-.5.1-1 .1-1.6 0 .4 1.3 1.6 2.2 3 2.2C7.2 15 5 15.6 3 15.2c2 1.2 4.4 1.9 6.9 1.9 8.3 0 12.8-7.2 12.8-13.4v-.6c.9-.7 1.6-1.6 2.1-2.6-.8.4-1.7.6-2.6.7z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Column 2: Links */}
        <div className="flex flex-col">
          <h5 className="text-white font-semibold mb-3">Quick Links</h5>
          <ul className="space-y-2 text-slate-300">
            <li>
              <Link to="/" className="hover:text-white transition">Home</Link>
            </li>
            <li>
              <Link to="/" className="hover:text-white transition">Available Job</Link>
            </li>
            <li>
              <Link to="/registration" className="hover:text-white transition">Registration</Link>
            </li>
            <li>
              <Link to="/login" className="hover:text-white transition">Login</Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Contact / Newsletter */}
        <div className="flex flex-col">
          <h5 className="text-white font-semibold mb-3">Contact</h5>
          <p className="text-sm text-slate-300 mb-3">Get job alerts and news direct to your inbox.</p>
          
          <div className="mt-4 text-slate-400 text-sm">
            <div>Phone: +8801762686275</div>
            <div>Email: info@cbiu.ac.bd</div>
          </div>
		  <div className="mt-4 text-slate-400 text-sm">
			<h3>Technical Support</h3>
            <div>Phone: 01979420300</div>
            <div>Email: yusuf.khalil88@gmail.com/admin@cbiu.ac.bd</div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 mt-6">
        <div className="max-w-7xl mx-auto px-6 py-4 text-slate-400 text-sm flex flex-col md:flex-row items-center justify-between">
          <div>© {new Date().getFullYear()} CBIU. All rights reserved.</div>
          <div className="mt-2 md:mt-0">Designed with ❤️ — CBIU Career</div>
        </div>
      </div>
    </footer>
  );
}
